module.exports = __webpack_public_path__ + "static/img/banner1.e8dcd4f0.png";